"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = require("@emotion/styled");
const theme_1 = require("../theme");
const MENU_COLLAPSE_BREAKPOINT = '870px';
exports.default = styled_1.default.div `
	.page-header {
		background: ${theme_1.default.colours.background.default};
		padding: 0 ${theme_1.default.spacing.large};
	}

	.page-header--collapsed {
		box-shadow: 0 1px 5px 0 ${theme_1.default.colours.shadow.default};
	}

	.page-header__container {
		max-width: ${theme_1.default.layout.container.maxWidth};
		padding: ${theme_1.default.spacing.default} 0;
		margin: 0 auto;
	}

	.page-header__upper {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.page-header__logo {
		width: 50px;
		transition: width ease-in-out ${theme_1.default.motion.transition.default};
	}

	.page-header--collapsed .page-header__logo {
		width: 40px;
	}

	.page-header__toggle {
		cursor: pointer;
		display: inline-flex;
		padding: ${theme_1.default.spacing.default} 0 ${theme_1.default.spacing.default} ${theme_1.default.spacing.default};
		align-items: center;
		color: ${theme_1.default.colours.text.dark};
		text-decoration: none;
	}

	.page-header__toggle::after {
		content: "";
		font-family: ${theme_1.default.typography.fonts.icons};
		margin-left: ${theme_1.default.spacing.default}
	}

	.page-header__toggle--open::after {
		content: "";
	}

	.page-header__list {
		margin: ${theme_1.default.spacing.large} 0 0;
		padding: 0;
		list-style: none;
	}

	.page-header__link {
		display: flex;
		align-items: center;
		padding: ${theme_1.default.spacing.default};
		color: ${theme_1.default.colours.text.dark};
		font-size: ${theme_1.default.typography.styles.d1.size};
		line-height: ${theme_1.default.typography.styles.d1.height};
		text-decoration: none;
		cursor: pointer;
		border-radius: ${theme_1.default.layout.radius.squared};
		transition: background ease-in-out ${theme_1.default.motion.transition.default};
	}

	.page-header__link:hover,
	.page-header__link--open,
	.page-header__link:focus {
		background: ${theme_1.default.colours.delimiter.default};
	}

	.page-header__link--parent::after {
		content: "";
		font-family: ${theme_1.default.typography.fonts.icons};
		line-height: 1;
		display: inline-block;
		vertical-align: text-top;
		margin-left: ${theme_1.default.spacing.default}
	}

	.page-header__link--open::after {
		content: "";
	}

	.page-header__link--shut + .page-header__list {
		display: none;
	}

	.page-header__list .page-header__list {
		margin-top: 0;
		padding-left: ${theme_1.default.spacing.large};
	}

	.page-header__navigation--hidden {
		display: none;
	}

	/* === Mobile popover navigation === */

	@media only screen and (max-width: ${(props) => props.breakpoint || MENU_COLLAPSE_BREAKPOINT}) {
		.page-header__navigation--visible {
			position: fixed;
			right: 0;
			left: 0;
			padding: 10px;
			background: #f7f7f7;
			height: calc(100vh - 60px);
			top: 60px;
			z-index: 999;
			overflow-y: auto;
		}

		.page-header--collapsed .page-header__navigation--visible {
			height: calc(100vh - 50px);
			top: 50px;
		}
	}

	@media only screen and (min-width: ${(props) => props.breakpoint || MENU_COLLAPSE_BREAKPOINT}) {
		.page-header__container {
			display: flex;
			align-items: center;
			padding ${theme_1.default.spacing.large} 0;
			transition: padding ease-in-out ${theme_1.default.motion.transition.default};
		}

		.page-header--collapsed .page-header__container {
			padding ${theme_1.default.spacing.default} 0;
		}

		.page-header__logo {
			margin-right: ${theme_1.default.spacing.default};
		}

		.page-header__toggle {
			display: none;
		}

		.page-header__navigation {
			display: flex;
			justify-content: space-between;
			flex-grow: 1;
		}

		.page-header__links {
			flex-grow: 1;
		}

		.page-header__list {
			margin: 0;
			display: flex;
		}

		/* === dropdown menu styles === */

		.page-header__list-item {
			position: relative;
		}

		.page-header__list-item .page-header__list {
			position: absolute;
			padding: 0;
			top: calc(100% + ${theme_1.default.spacing.default});
			left: 0;
			display: block;
			min-width: 220px;
			overflow: hidden;
			background: ${theme_1.default.colours.background.lighter};
			border: 1px solid ${theme_1.default.colours.delimiter.default};
			border-radius: ${theme_1.default.layout.radius.squared};
			box-shadow: 0 1px 5px 0 ${theme_1.default.colours.shadow.default};
		}

		.page-header__sublinks .page-header__list-item .page-header__list {
			left: auto;
			right: 0;
		}

		.page-header__link--shut + .page-header__list {
			display: none;
		}

		.page-header__list-item .page-header__list .page-header__link {
			padding: ${theme_1.default.spacing.default};
			border-radius: 0;
		}

		.page-header__list-item .page-header__list .page-header__link:hover {
			background: ${theme_1.default.colours.background.default};
		}
	}
`;
//# sourceMappingURL=page-header.styled.js.map